import { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import ChartWrapper from '../../../components/Charts/ChartWrapper';
import LineChart from '../../../components/Charts/LineChart';
import useChartFilter from '../../../hooks/dashboard/companyInsight/useChartFilter';
import ChartFilter from './ChartFilter';

const OnboardingChart = () => {
  const { chartFilter, chartData } = useChartFilter();

  const [dataUrl, setDataUrl] = useState<string>(
    `ba/v1/company/onboarding-timeline`,
  );

  useEffect(() => {
    if (!dataUrl) return;

    chartFilter(dataUrl);
    // eslint-disable-next-line
  }, [dataUrl]);

  return (
    <Container>
      <ChartWrapper maxWidth='100%'>
        <HeaderArea>
          <Header>Company Lifetime Onboarding Chart</Header>

          <ControlArea>
            <ChartFilter setDataUrl={setDataUrl} dataUrl={dataUrl} />
          </ControlArea>
        </HeaderArea>

        <LineChart
          xAxisDataKey='monthName'
          data={chartData ?? []}
          isAnimationActive={true}
          dataKeys={['cumulativeTotal']}
          strokes={['#5B91F5']}
          types={[
            // 'monotone',
            'linear',
          ]}
          showLegend={false}
          aspect={3}
          tooltipLabel='Lifetime Onboarding'
        />
      </ChartWrapper>
    </Container>
  );
};

export default OnboardingChart;

const Container = styled.div`
  width: 100%;
  grid-column: span 3;
`;

const ControlArea = styled.div`
  display: flex;
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;

  /* border: 1px solid red; */
  margin-bottom: 18px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;
